import React from 'react'
import Head from 'next/head'
import Layout from '../../../components/Layout/Layout'
import { withRouter } from 'next/router'
import { EventTrackingConsumer } from '../../../components/EventTrackingProvider/EventTrackingProvider'
import { GTM_ENV_VAR as GEV } from '../../../lib/eventTrackerFunction'
import { getExpConfig } from '../../../utils/configService'
import { SPLIT_FEATURES } from '../../../utils/constants'
import { createGlobalStyle } from 'styled-components'

const GlobalStyle = createGlobalStyle`
 .publitas-container {
    position: relative;
    width: 100%;
    height: 0;
    padding-top: 130%;
  }
  @media (min-width: 767px) {
    .publitas-container {
      padding-top: 66%;
    }
  }
  .publitas-container iframe {
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    width: 100%;
    height: 100%;
  }
`
class WeeklyPromos extends React.Component {
  constructor(props) {
    super(props)
    this.getContent = this.getContent.bind(this)
  }
  componentDidMount() {
    const publitasSplit = getExpConfig(SPLIT_FEATURES.PUBLITAS)
    const isEnablePublitasSplit = publitasSplit?.treatment === 'on'
    const that = this
    /* istanbul ignore next */
    if (isEnablePublitasSplit) {
      window.addEventListener(
        'message',
        function (event) {
          if (event.origin !== 'https://view.publitas.com') {
            return
          }
          const payload = JSON.parse(event.data)
          if (payload && payload.event) {
            that.props.track(payload)
          }
        },
        false
      )
    }
    const { slug, skuid } = this.props?.router?.query || {}
    this.props.track({
      [GEV.USER_ID]: skuid,
      [GEV.PAGE_TYPE]: 'promotion',
      [GEV.SCREEN_NAME]: `promotions - ${slug}`,
      [GEV.EVENT_CAT]: 'internal promotions',
      [GEV.EVENT_ACTION]: 'landed',
      [GEV.EVENT_LABEL]: 'swa publitas',
    })
  }

  getContent(skuid, slug) {
    if (typeof window !== 'undefined') {
      const promo1Url = `https://view.publitas.com/fairpricegroup/pdbn-fresh-vpjzdakrz646/?publitas_embed=maximized&skuid=${skuid}`
      const promo2Url = `https://view.publitas.com/fairpricegroup/pdbn-fresh-7eyjjw7rjgo8/?publitas_embed=maximized&skuid=${skuid}`
      const promo3Url = `https://view.publitas.com/fairpricegroup/pdbn-fresh-7eyjjw7rjgo8-apdgq3oogbj9/?publitas_embed=maximized&skuid=${skuid}`
      const promo4Url = `https://view.publitas.com/fairpricegroup/pdbn-fresh-7eyjjw7rjgo8-by3kb6ejg_gk/?publitas_embed=maximized&skuid=${skuid}`
      const promo5Url = `https://view.publitas.com/fairpricegroup/pdbn-fresh/?publitas_embed=maximized&skuid=${skuid}`
      switch (slug) {
        case 'weekly-promo-1':
          return (
            <div data-testid="weekly-promo-1">
              <div
                className="publitas-container"
                dangerouslySetInnerHTML={{
                  __html: `
               <iframe src=${promo1Url} style="display: block; box-sizing: border-box;" frameborder="0" allowfullscreen="allowfullscreen"></iframe>`,
                }}
              />
            </div>
          )
        case 'weekly-promo-2':
          return (
            <div data-testid="weekly-promo-2">
              <div
                className="publitas-container"
                dangerouslySetInnerHTML={{
                  __html: `
               <iframe src=${promo2Url} style="display: block; box-sizing: border-box;" frameborder="0" allowfullscreen="allowfullscreen"></iframe>`,
                }}
              />
            </div>
          )
        case 'weekly-promo-3':
          return (
            <div data-testid="weekly-promo-3">
              <div
                className="publitas-container"
                dangerouslySetInnerHTML={{
                  __html: `
               <iframe src=${promo3Url} style="display: block; box-sizing: border-box;" frameborder="0" allowfullscreen="allowfullscreen"></iframe>`,
                }}
              />
            </div>
          )
        case 'weekly-promo-4':
          return (
            <div data-testid="weekly-promo-4">
              <div
                className="publitas-container"
                dangerouslySetInnerHTML={{
                  __html: `
               <iframe src=${promo4Url} style="display: block; box-sizing: border-box;" frameborder="0" allowfullscreen="allowfullscreen"></iframe>`,
                }}
              />
            </div>
          )
        case 'weekly-promo-5':
          return (
            <div data-testid="weekly-promo-5">
              <div
                className="publitas-container"
                dangerouslySetInnerHTML={{
                  __html: `
               <iframe src=${promo5Url} style="display: block; box-sizing: border-box;" frameborder="0" allowfullscreen="allowfullscreen"></iframe>`,
                }}
              />
            </div>
          )
        default:
          return <div data-testid="no-promo" />
      }
    } else {
      return <div />
    }
  }

  render() {
    const { organizationData, categoryList, router } = this.props
    const { skuid, slug } = router?.query || {}
    return (
      <>
        <Head>
          <title>{slug} | NTUC FairPrice</title>
        </Head>
        <Layout
          organizationData={organizationData}
          categoryList={categoryList}
          noWrapper="noGap"
        >
          {this.getContent(skuid, slug)}
          <GlobalStyle />
        </Layout>
      </>
    )
  }
}

const WeeklyPromosPageWrapper = props => (
  <EventTrackingConsumer>
    {({ track }) => <WeeklyPromos {...props} track={track} />}
  </EventTrackingConsumer>
)

export default withRouter(WeeklyPromosPageWrapper)
